import {
  IconButton,
  Grid,
  Button,
  Box,
  Modal,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

// open: boolean,
// setOpen: () => void,
// title?: string,
// message?: string,
// buttons?: {
//     name: string,
//     color: string,       according to theme context, refer MUI button for more info.
//     func: () => void,
//     disabled?: boolean,
//     loading?: boolean,
//     keepModalOpen?: boolean,
// }[],

const style = {
  display: "block",
  position: "fixed",
  top: "42%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: 4,
  width: "90%",
  maxWidth: 450,
  background: "white",
  boxShadow: 24,
  padding: 3.7,
};

function CustomModal({
  open,
  setOpen,
  title = "",
  message = "",
  buttons = [],
  children,
}) {
  return (
    <Modal
      open={open}
      onClose={() => {
        if (!buttons.some((button) => button.loading)) {
          setOpen(false);
        }
      }}
    >
      <Box sx={style}>
        <IconButton
          style={{ position: "absolute", top: 3, right: 3 }}
          onClick={() => setOpen(false)}
          disabled={buttons.some((button) => button.loading)}
        >
          <CloseRoundedIcon />
        </IconButton>
        {title.length > 0 && (
          <Typography marginRight={3} variant="h6">
            {title}
          </Typography>
        )}
        {message &&
          (typeof message === "string" && message.length > 0 ? (
            <Typography
              sx={{ marginTop: 1, fontSize: "15px", whiteSpace: "pre-line" }}
              marginRight={3}
            >
              {message}
            </Typography>
          ) : (
            <Box sx={{ marginTop: 1 }} marginRight={3}>
              {message}
            </Box>
          ))}
        {children && (
          <Box sx={{ marginTop: 2 }} marginRight={3}>
            {children}
          </Box>
        )}
        <Grid
          container
          mt={3}
          alignItems="center"
          justifyContent="flex-end"
          rowSpacing={1}
          columnSpacing={1}
        >
          {buttons.map((button, i) => (
            <Grid item key={i}>
              <Button
                variant="contained"
                disableElevation
                style={{ borderRadius: 7 }}
                color={button.color || "primary"}
                disabled={button.disabled || button.loading}
                onClick={() => {
                  if (!button.disabled && !button.loading) {
                    button.func();
                    if (!button.keepModalOpen) {
                      setOpen(false);
                    }
                  }
                }}
              >
                {button.loading ? (
                  <CircularProgress size={22} color="inherit" />
                ) : (
                  <strong>{button.name}</strong>
                )}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  );
}

export default CustomModal;
